import gql from 'graphql-tag';
import { useQuery as defaultUseQuery } from '@apollo/react-hooks';

import { accountFragment } from '@zapier/upsells/src/fragments';
import { useCurrentAccountId } from '@zapier/upsells/src/hooks';
import {
  ApolloInjection,
  CurrentAccountQuery,
} from '@zapier/upsells/src/types';

export const currentAccountQuery = gql`
  query upsells_currentAccountQuery($accountId: Int!) {
    account(id: $accountId) {
      ...upsells_accountFragment
    }
  }
  ${accountFragment}
`;

export const useCurrentAccount = (props?: ApolloInjection) => {
  const useQuery = props?.useQuery || defaultUseQuery;
  const { accountId } = useCurrentAccountId({ useQuery });

  const { data, error, loading: isLoading } = useQuery<CurrentAccountQuery>(
    currentAccountQuery,
    {
      skip: !accountId,
      variables: {
        accountId,
      },
    }
  );

  return {
    currentAccount: data?.account,
    error: error?.message,
    isLoading,
  };
};
